import types from '@/store/types/Solicitud'
import typesPromociones from '@/store/types/PromocionesEmpresariales';

import typesDesistimientoRenuncia from '@/store/types/DesistimientoRenuncia';
import typesDocsPosteriores from "@/store/types/DocumentosPosteriores";
import typesDocumentos from "@/store/types/Documentos";

import typesAmpliacion from '@/store/types/Ampliacion';

import typesDetalleInclusionExclusion from '@/store/types/DetalleInclusionExclusion';

import Vue from 'vue';

const state = {
    solicitud: {},
    datosEmpresa: {},
    adjuntosEnviados:{}
}
const getters = {
    [types.getters.GetDatosSolicitud]:(state) => {
        let objSol = state.solicitud;
        return objSol;
    },
    [types.getters.GetDatosEmpresa]:(state) => {
        let objSol = state.datosEmpresa;
        return objSol;
    },
}
const mutations = {
    [types.mutations.SetDatosSolicitud]:(state, obj) => {
        state.solicitud = obj;
    },
    [types.mutations.SetDatosEmpresa]:(state, obj) => {
        state.datosEmpresa = obj;
    },
}
const actions = {
    [types.actions.LimpiarSolicitudTodos]:({commit})=>{
        commit(typesPromociones.mutations.SetdatosPe,{})
    },
    [types.actions.LimpiarSolicitudAmpliacion]:({commit})=>{

        commit(typesPromociones.mutations.SetdatosPe,{})
        commit(typesAmpliacion.mutations.SetAmpliacion,{})
    },

    [types.actions.LimpiarInclusionExclusion]:({commit})=>{
        commit(typesAmpliacion.mutations.SetAmpliacion,{})
        commit(typesPromociones.mutations.SetPromocionesEnviadasNetTodos,{})
        commit(typesDetalleInclusionExclusion.mutations.SetlstInclusionExclusion,[])
    },
    [types.actions.LimpiarSolicitudDesistimiento]:({commit})=> {
        //commit(types.mutations.SetDatosSolicitud, {});
        commit(typesDesistimientoRenuncia.mutations.SetDatosDesistimientoPe, {});
        commit(typesDocumentos.mutations.SetDocumentos, []);
    },
    [types.actions.LimpiarSolicitudDocsPosteriores]:({commit})=> {
        commit(typesDocsPosteriores.mutations.SetDatosDocsPosterioresPe, {});
        commit(typesDocumentos.mutations.SetDocumentos, []);
        commit(typesDocsPosteriores.mutations.SetMostrarDetalle, false);
    },

    [types.actions.RegistrarSolicitud]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.post(`pajel/solicitud/add`,pObj)
            .then(r => {
                let obj = r.data.resultado;
                commit(types.mutations.SetDatosSolicitud, obj);
                resolve(r);
           })
           .catch(error => console.error("ERROR EN LA API:: "+error))
        })
    },

    [types.actions.EnviarSolicitud]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.post(`pajel/promocion_empresarial/net/enviar_solicitud`,pObj).then(r=>{
                resolve(r);
            })
        })
    },
    [types.actions.ObtenerSolicitud]:({commit}, pObj) => {
        return new Promise ((resolve, reject)=>{
            Vue.prototype.$http.get(`pajel/solicitud/find/${pObj}`)
                .then(r => {
                    commit(types.mutations.SetDatosSolicitud, r.data)
                    resolve(r);
                });
        });
    },
    [types.actions.EliminarSolicitud]:({commit},pSolicitudId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.delete(`pajel/solicitud/delete/${pSolicitudId}`).then(r=>{
                resolve(r);
            })
        })
    },
    [types.actions.ObtenerDatosEmpresa]:({commit}, pPromocionEmpresarialNetId) => {
        return new Promise ((resolve, reject)=>{
            //Vue.prototype.$http.get(`pajel/promocion_empresarial/net/find/${pPromocionEmpresarialNetId}`)
            Vue.prototype.$http.get(`pajel/promocion_empresarial/promocionEmpresarialNet/${pPromocionEmpresarialNetId}`)
                .then(r => {
                    commit(types.mutations.SetDatosEmpresa, r.data)
                    resolve(r);
                });
        });
    },
    [types.actions.SeguimientoTramite]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.post(`pajel/solicitud/seguimiento_tramite/${pObj.pUsuarioEmpresaId}/${pObj.pTramiteId}`, pObj).then(r=>{
                resolve(r);
            })
        })
    },

    [types.actions.BusquedaTramite]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/busqueda/detalle_seguimiento/tramite/${pObj.pTramiteId}/${pObj.pPersonaId}`, pObj).then(r=>{
                resolve(r);
            })
        })
    },

    [types.actions.ActualizarSolicitud]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.put(`pajel/solicitud/update/${pObj.solicitudId}`,pObj)
            .then(r => {
                resolve(r);
           })
        })
    },

    [types.actions.filtroSolicitud]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/solicitud/list/${pObj.pUsuarioEmpresaId}/${pObj.pOficinaId}/${pObj.pTipoTramiteId}/${pObj.pEstadoSolicitudId}`)
            .then(r => {
                resolve(r);
           })
        })
    },
    [types.actions.horarioAtencionByOficinaId]:({commit},pOficinaID)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/solicitud/horarioAtencionByOficinaId/${pOficinaID}`)
            .then(r => {
                resolve(r);
           })
        })
    },
    [types.actions.horarioTopeAtencionByOficinaId]:({commit},pOficinaID)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/solicitud/horarioTopeAtencionByOficinaId/${pOficinaID}`)
            .then(r => {
                resolve(r);
           })
        })
    },
    [types.actions.detalleSolicitud]:({commit},payload)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/solicitud/detalle/${payload.pTramiteId}/${payload.pTipo}`)
            .then(r => {
                resolve(r);
           })
        })
    },
    [types.actions.detalleSolicitudPajelV1]:({commit},payload)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/pajelV1/solicitud/adjuntos/${payload.pTramiteId}/${payload.pTipo}`)
            .then(r => {
                resolve(r);
           })
        })
    },
}
export default {
    state,
    actions,
    getters,
    mutations
}
